










































import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { getGroupEvents } from '@front-app/services/GroupsApi/GroupsEventsApi';
import { STARTABLE_STATUSES } from '@front-app/store/util/cache';
import { Size } from '@front-app/components/constants';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import {
	computed,
	ComputedRef,
	defineComponent,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import SearchBox from '../search/SearchBox.vue';
import SearchPlaceholder from '../search/SearchPlaceholder.vue';
import SearchResult from '../search/SearchResult.vue';
import { useRollingIndex } from '../search/useRollingIndex';
import { SearchOption, useEventSearch } from '../search/useSearch';

export default defineComponent({
	components: {
		SearchBox,
		SearchPlaceholder,
		SearchResult,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		excludedEventIds: {
			type: Array as PropType<string[]>,
			default: () => [],
		},
		resultSize: {
			type: String as PropType<Size>,
			default: Size.SMALL,
		},
		position: {
			type: Number as PropType<DropdownPosition>,
			default: DropdownPosition.BOTTOM_RIGHT,
		},
	},
	setup(props, ctx) {
		const {
			track,
			status: searchFetchStatus,
			isLoading: isSearchLoading,
		} = useAsyncStatus();
		const events: Ref<EventV2[]> = ref([]);
		const prefetchSearchData = async (force = false) => {
			if (force || STARTABLE_STATUSES.includes(searchFetchStatus.value)) {
				events.value = await track(getGroupEvents(props.groupId));
			}
		};
		watch(() => props.groupId, (curr, prev) => {
			if (curr === prev) {
				return;
			}
			prefetchSearchData(true);
		});

		const allSearch = useEventSearch(events);
		const searchValue = allSearch.searchString;
		const allSearchResults: ComputedRef<SearchOption<EventV2>[]> = computed(() => allSearch.results.value
			.filter((result) => Boolean(result.key))
			.filter(({ original }) => !props.excludedEventIds.includes(original.id))
			.sort((a, b) => a.title.localeCompare(b.title)));

		const searchFocus = useRollingIndex(allSearchResults);
		const focusedSearchIdx = searchFocus.selectedIdx;
		const focusNextSearchResult = searchFocus.next;
		const focusPrevSearchResult = searchFocus.prev;

		const clearSearch = () => {
			focusedSearchIdx.value = null;
			searchValue.value = '';
		};

		const openResult = (result: SearchOption<EventV2>) => {
			ctx.emit('select', result);
			clearSearch();
		};
		const openFirstSearchResult = () => {
			if (allSearchResults.value.length === 0) {
				return;
			}
			const firstResult = allSearchResults.value[0];
			openResult(firstResult);
		};
		return {
			clearSearch,
			focusedSearchIdx,
			focusNextSearchResult,
			focusPrevSearchResult,
			searchValue,
			prefetchSearchData,
			allSearchResults,
			openFirstSearchResult,
			openResult,
			isSearchLoading,
			hoveredItem: ref(null),
		};
	},
});
